import * as React from "react";

import { Part } from "./part";
import { GroupContainer, GroupTitle } from "./group-container";
import { twMerge } from "tailwind-merge";
// https://github.com/radix-ui/primitives/discussions/1058

type VerticalGroupProps = {
  data: Map<string, Record<PropertyKey, unknown>>;
  name: string;
  className?: string | undefined;
  scaleItems?: boolean;
  isDisabled?: boolean;
};

export function VerticalGroup({
  data,
  name,
  className = "",
  scaleItems,
  isDisabled,
}: VerticalGroupProps) {
  const entries = [...data.entries()];

  return (
    <GroupContainer>
      <ul
        className={twMerge(
          "flex flex-col justify-start gap-5 px-5 py-4",
          className
        )}
      >
        {entries.map(([name, data]) => (
          <Part
            key={name}
            // type={data.type}
            isDisabled={isDisabled}
            data={data}
            name={name}
            scaleItems={scaleItems}
          />
        ))}
      </ul>
      <GroupTitle>{name}</GroupTitle>
    </GroupContainer>
  );
}
